import { Button, ButtonProps } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface ButtonNewItemProps extends ButtonProps {
	onClick: () => void;
	children?: React.ReactNode;
	props?: any;
}

export function ButtonNewItem({
	onClick,
	children = "Add New Item",
	...props
}: ButtonNewItemProps) {
	return (
		<Button
			variant="ghost-teal"
			onClick={onClick}
			leftIcon={<FontAwesomeIcon icon={["far", "circle-plus"]} />}
			{...props}
		>
			{children}
		</Button>
	);
}
